import Icon from 'components/icons/Icon';
import { Size } from 'components/types';
import { Component, Prop } from 'vue-property-decorator';
import { Component as TsxComponent } from 'vue-tsx-support';
import { IconName } from 'components/icons/types';
import styles from './navigation-button.css';

interface Props {
  disabled?: boolean;
  route: string;
  icon?: IconName.ARROW_NEXT | IconName.DONE;
}

@Component
export default class NavigationButton extends TsxComponent<Props> {
  @Prop()
  public disabled: Props['disabled'];

  @Prop()
  public route: Props['route'];

  @Prop()
  public icon: Props['icon'];

  public render() {
    return (
      <router-link
        activeClass={styles.navigationButtonActive}
        aria-disabled={this.disabled}
        class={[styles.navigationButton, this.disabled && styles.navigationButtonDisabled]}
        event={this.disabled ? [] : undefined}
        to={this.disabled ? '#' : { name: this.route }}
      >
        {this.$slots.default}
        {this.icon && (
          <Icon name={this.icon} size={Size.SMALL} class={styles.navigationButtonIcon} />
        )}
      </router-link>
    );
  }
}
